
<div class="main">
  <div class="header-wrapper">
    <app-header></app-header>
  </div>

  <div class="wrap">
    <router-outlet></router-outlet>

  </div>

  <div class="footer-wrapper">
    <app-footer></app-footer>
    <!-- <app-mob-sidenav></app-mob-sidenav> -->

  </div>

</div>










